import "core-js/modules/es.error.cause.js";
import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import { login, logout, getAdminInfo, verifyOtp, loginWithOtp } from '@/api/admins';
import { agentLogin, agentLogout, getAgentInfo, agentRequestOtp, agentVerifyOtp } from '@/api/agents-users';
import { getToken, setToken, removeToken } from '@/utils/cookies';
import router, { resetRouter } from '@/router';
import { PermissionModule } from './permission';
import { TagsViewModule } from './tags-view';
import store from '@/store';
let Admin = class Admin extends VuexModule {
  constructor() {
    super(...arguments);
    this.token = getToken() || '';
    this.name = '';
    this.avatar = '';
    this.roles = [];
    this.email = '';
    this.id = 0;
    this.adminsRoleId = 0;
    this.adminsRoleIds = [];
    this.userType = '';
    this.branchIds = [];
    this.agentId = null;
    this.forcedLogout = true;
  }
  SET_TOKEN(token) {
    this.token = token;
  }
  SET_NAME(name) {
    this.name = name;
  }
  SET_AVATAR(avatar) {
    this.avatar = avatar;
  }
  SET_ID(id) {
    this.id = id;
  }
  SET_ROLES(roles) {
    this.roles = roles;
  }
  SET_BRANCH_IDS(branchIds) {
    this.branchIds = branchIds;
  }
  SET_ROLE_ID(adminsRoleId) {
    this.adminsRoleId = adminsRoleId;
  }
  SET_ROLE_IDS(adminsRoleIds = []) {
    this.adminsRoleIds = adminsRoleIds;
  }
  SET_AGENT_ID(agentId) {
    this.agentId = agentId;
  }
  SET_EMAIL(email) {
    this.email = email;
  }
  SET_TYPE(userType) {
    this.userType = userType;
  }
  SET_FORCED_LOGOUT(forcedLogout) {
    this.forcedLogout = forcedLogout;
  }
  async Login(adminInfo) {
    let {
      email,
      password
    } = adminInfo;
    email = email.trim();
    password = password.trim();
    try {
      const data = await login({
        email,
        password
      });
      setToken(data.accessToken);
      this.SET_TOKEN(data.accessToken);
      return getAdminInfo({});
    } catch (error) {
      this.ResetToken();
      return Promise.reject(error);
    }
  }
  async requestOtp(mobileNumber) {
    mobileNumber = mobileNumber.trim();
    try {
      // Request OTP by sending the mobile number
      const data = await loginWithOtp({
        mobileNumber
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async verifyOtp(otpInfo) {
    let {
      mobileNumber,
      otp,
      hash
    } = otpInfo;
    mobileNumber = mobileNumber.trim();
    otp = otp.trim();
    try {
      // Verify OTP and get token
      const data = await verifyOtp({
        mobileNumber,
        otp,
        hash
      });
      console.log('verifyOtp backend response:', data);
      const token = data.accessToken || data.token;
      if (!token) {
        throw new Error('Backend did not return an accessToken in the verifyOtp response!');
      }
      setToken(token);
      this.SET_TOKEN(token);
      return getAdminInfo({}); // Fetch admin info after successful login
    } catch (error) {
      this.ResetToken();
      return Promise.reject(error);
    }
  }
  async AgentLogin(adminInfo) {
    let {
      email,
      password
    } = adminInfo;
    email = email.trim();
    password = password.trim();
    try {
      const data = await agentLogin({
        email,
        password
      });
      setToken(data.accessToken);
      this.SET_TOKEN(data.accessToken);
      return getAgentInfo({});
    } catch (error) {
      this.ResetToken();
      return Promise.reject(error);
    }
  }
  async AgentRequestOtp(mobileNumber) {
    mobileNumber = mobileNumber.trim();
    try {
      // Request OTP by sending the mobile number
      const data = await agentRequestOtp({
        mobileNumber
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async AgentVerifyOtp(otpInfo) {
    let {
      mobileNumber,
      otp,
      hash
    } = otpInfo;
    mobileNumber = mobileNumber.trim();
    otp = otp.trim();
    try {
      // Verify OTP and get token
      const data = await agentVerifyOtp({
        mobileNumber,
        otp,
        hash
      });
      console.log('agentVerifyOtp backend response:', data);
      const token = data.accessToken || data.token;
      if (!token) {
        throw new Error('Backend did not return an accessToken in the verifyOtp response!');
      }
      setToken(token);
      this.SET_TOKEN(token);
      return getAgentInfo({}); // Fetch agent info after successful login
    } catch (error) {
      this.ResetToken();
      return Promise.reject(error);
    }
  }
  ResetToken() {
    removeToken();
    this.SET_TOKEN('');
    this.SET_ROLES([]);
    this.SET_BRANCH_IDS([]);
    this.SET_ROLE_ID(0);
  }
  async GetAdminInfo() {
    if (this.token === '') {
      throw Error('GetAdminInfo: token is undefined!');
    }
    const data = await getAdminInfo({});
    if (!data) {
      throw Error('Verification failed, please Login again.');
    }
    const branchIds = data.branchIds || [];
    localStorage.setItem('uuid', data.uuid);
    this.SET_ROLES(data.roles);
    // this.SET_ROLES(['Super Admin'])
    this.SET_BRANCH_IDS(branchIds);
    this.SET_NAME(data.fullName);
    // this.SET_AVATAR(avatar)
    this.SET_ID(data.id);
    this.SET_EMAIL(data.emailAddress);
    this.SET_ROLE_ID(data.adminsRoleId);
    // this.SET_ROLES([data.roles])
    this.SET_ROLE_IDS(data.adminsRoleIds);
    this.SET_TYPE(data.userType);
    this.SET_AGENT_ID(data.agentId);
    this.SET_FORCED_LOGOUT(data.forcedLogout);
    // startIdleTracking(this.userType == 'Agent' ? this.agentId : this.id)
    return data;
  }
  async ChangeRoles(role) {
    // Dynamically modify permissions
    this.SET_ROLES([role]);
    this.SET_ROLE_ID(0);
    const token = role + '-token';
    this.SET_TOKEN(token);
    setToken(token);
    await this.GetAdminInfo();
    resetRouter();
    // Generate dynamic accessible routes based on roles
    PermissionModule.GenerateRoutes(this.roles);
    // Add generated routes
    router.addRoutes(PermissionModule.dynamicRoutes);
    // Reset visited views and cached views
    TagsViewModule.delAllViews();
  }
  async LogOut() {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!');
    }
    localStorage.removeItem('uuid');
    // stopIdleTracking(this.userType == 'Agent' ? this.agentId : this.id)
    await logout();
    removeToken();
    resetRouter();
    // Reset visited views and cached views
    TagsViewModule.delAllViews();
    this.SET_TOKEN('');
    this.SET_ROLES([]);
    this.SET_ROLE_ID(0);
    this.SET_ROLE_IDS([]);
  }
  async AgentLogOut() {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!');
    }
    await agentLogout();
    removeToken();
    resetRouter();
    // Reset visited views and cached views
    TagsViewModule.delAllViews();
    this.SET_TOKEN('');
    this.SET_ROLES([]);
    this.SET_ROLE_ID(0);
  }
};
__decorate([Mutation], Admin.prototype, "SET_TOKEN", null);
__decorate([Mutation], Admin.prototype, "SET_NAME", null);
__decorate([Mutation], Admin.prototype, "SET_AVATAR", null);
__decorate([Mutation], Admin.prototype, "SET_ID", null);
__decorate([Mutation], Admin.prototype, "SET_ROLES", null);
__decorate([Mutation], Admin.prototype, "SET_BRANCH_IDS", null);
__decorate([Mutation], Admin.prototype, "SET_ROLE_ID", null);
__decorate([Mutation], Admin.prototype, "SET_ROLE_IDS", null);
__decorate([Mutation], Admin.prototype, "SET_AGENT_ID", null);
__decorate([Mutation], Admin.prototype, "SET_EMAIL", null);
__decorate([Mutation], Admin.prototype, "SET_TYPE", null);
__decorate([Mutation], Admin.prototype, "SET_FORCED_LOGOUT", null);
__decorate([Action({
  rawError: true
})], Admin.prototype, "Login", null);
__decorate([Action({
  rawError: true
})], Admin.prototype, "requestOtp", null);
__decorate([Action({
  rawError: true
})], Admin.prototype, "verifyOtp", null);
__decorate([Action({
  rawError: true
})], Admin.prototype, "AgentLogin", null);
__decorate([Action({
  rawError: true
})], Admin.prototype, "AgentRequestOtp", null);
__decorate([Action({
  rawError: true
})], Admin.prototype, "AgentVerifyOtp", null);
__decorate([Action], Admin.prototype, "ResetToken", null);
__decorate([Action], Admin.prototype, "GetAdminInfo", null);
__decorate([Action], Admin.prototype, "ChangeRoles", null);
__decorate([Action], Admin.prototype, "LogOut", null);
__decorate([Action], Admin.prototype, "AgentLogOut", null);
Admin = __decorate([Module({
  dynamic: true,
  store,
  name: 'admin'
})], Admin);
export const AdminModule = getModule(Admin);